import "@/lib/polyfills/promise-with-resolvers";
import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

const PRELOAD_RELOAD_KEY = "vite:preload-reload";

// Recover from stale/failed lazy chunks after deploy — at most one reload per tab.
// Only preventDefault when we actually reload; otherwise React.lazy gets undefined.default.
window.addEventListener("vite:preloadError", (event) => {
  try {
    if (sessionStorage.getItem(PRELOAD_RELOAD_KEY) === "1") return;
    sessionStorage.setItem(PRELOAD_RELOAD_KEY, "1");
  } catch {
    // No reliable reload cap without storage — don't intercept (avoids infinite loops).
    return;
  }
  event.preventDefault();
  window.location.reload();
});

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD,
  sendDefaultPii: false,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  tracesSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  replaysSessionSampleRate: 0.05,
});

createRoot(document.getElementById("root")!).render(<App />);
